module.exports = __webpack_public_path__ + "static/media/20210109_204320_112_IMG_1681.9dee39b9.jpg";